module.exports = __webpack_public_path__ + "static/img/高收益意味着高风险.51daad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/高收益意味着高风险.png
// module id = sPpo
// module chunks = 1